// import moment from 'moment'
/**
 * ! ข้อควรระวัง ค่าใน model ต้องเป็น string!!!
 * * Used:
 * * In template
    <v-text-field
      :rules="[$rules.required]"
    ></v-text-field>
 * * In script
 *  this.$rules.required
 */

export const rules = {
  required: value => !!value || 'กรุณากรอกข้อมูล',
  array_required: value =>
    (value !== null && (value === undefined || value.length > 0)) ||
    'กรุณาเลือกข้อมูลอย่างน้อย 1 รายการ',
  required_zero_allow: value =>
    ((value || value === 0) && value !== '') ||
    'กรุณากรอกข้อมูล',
  is_number_only: value =>
    /^[0-9]+$/.test(value) || 'กรุณากรอกเฉพาะตัวเลขเท่านั้น',
  numeric: value => !isNaN(value) || 'กรุณากรอกตัวเลขเท่านั้น',
  positive: value => Number(value) >= 0 || 'กรุณากรอกตัวเลขที่มากกว่าหรือเท่ากับ 0',
  more_than_zero: value => Number(value) > 0 || 'กรุณากรอกตัวเลขที่มากกว่า 0',
  not_zero: value => Number(value) !== 0 || 'กรุณากรอกตัวเลขที่ไม่ใช่ 0',
  empty_or_numeric: function (value) {
    if (value !== undefined && isNaN(value)) {
      return 'กรุณากรอกตัวเลขเท่านั้น'
    } else {
      return true
    }
  },
  empty_or_integer: function (value) {
    if (value === undefined || value === null || value === '') {
      return true
    } else if (Number(value) <= 0 || !Number.isInteger(Number(value))) {
      return 'กรุณากรอกจำนวนเต็มที่มากกว่า 0 หรือปล่อยว่าง'
    }
    return true
  },
  alphanumeric: value =>
    /^[a-zA-Z0-9-.@_]*$/.test(value) || 'กรุณากรอกเฉพาะตัวอักษรภาษาอังกฤษ ตัวเลข และเครื่องหมาย .-@_ เท่านั้น',
  letter_or_digit: function (value) {
    let format = /[ !@#$%^&*()_+=[\]{};':"\\|,.<>?]/
    if (format.test(value)) return 'กรุณากรอกเฉพาะตัวอักษรและตัวเลขเท่านั้น (ห้ามใช้เครื่องหมายพิเศษ)'
    else return true
  },
  upper_case_alphanumeric: value =>
    /^[A-Z0-9]*$/.test(value) || 'กรุณากรอกเฉพาะตัวอักษรภาษาอังกฤษตัวใหญ่และตัวเลขเท่านั้น',
  integer: value =>
    Number.isInteger(Number(value)) || 'กรุณากรอกจำนวนเต็มเท่านั้น',
  number_lte: n => value =>
    Number(value) <= n || `กรุณากรอกตัวเลขที่น้อยกว่าหรือเท่ากับ ${n}`,
  number_lt: n => value =>
    Number(value) < n || `กรุณากรอกตัวเลขที่น้อยกว่า ${n}`,
  number_gte: n => value =>
    Number(value) >= n || `กรุณากรอกตัวเลขที่มากกว่าหรือเท่ากับ ${n}`,
  number_gt: n => value =>
    Number(value) > n || `กรุณากรอกตัวเลขที่มากกว่า ${n}`,
  minlength: n => value =>
    value.length >= n || `กรุณากรอกข้อมูลอย่างน้อย ${n} ตัวอักษร`,
  maxlength: n => value =>
    !value || value.length <= n || `กรุณากรอกข้อมูลไม่เกิน ${n} ตัวอักษร`,
//   is_date(value) {
//     if (!value) return true

//     let date = moment(value)
//     if (!date.isValid()) {
//       return 'กรุณากรอกวันที่ให้ถูกต้อง'
//     }

//     if (date.year() < 1900) {
//       return 'กรุณากรอกวันที่ไม่เก่ากว่า ค.ศ. 1900'
//     }

//     return true
//   },
//   min_date(date) {
//     return value =>
//       moment(value).isSameOrAfter(date) || `กรุณากรอกวันที่ไม่เก่ากว่า ${moment(date).format('DD/MM/YYYY')}`
//   },
//   max_date(date) {
//     return value =>
//       moment(value).isSameOrBefore(date) || `กรุณากรอกวันที่ไม่ใหม่กว่า ${moment(date).format('DD/MM/YYYY')}`
//   },
//   min_date_allow_empty(date) {
//     return value => {
//       if (moment(value).isSameOrAfter(date) || !value) return true
//       else return `กรุณากรอกวันที่ไม่เก่ากว่า ${moment(date).format('DD/MM/YYYY')}`
//     }
//   },
//   max_date_allow_empty(date) {
//     return value => {
//       if (moment(value).isSameOrBefore(date) || !value) return true
//       else return `กรุณากรอกวันที่ไม่ใหม่กว่า ${moment(date).format('DD/MM/YYYY')}`
//     }
//   },
  is_time(value) {
    if (!value) return true
    const regex = /(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])/
    return regex.test(value) || 'กรุณากรอกเวลาให้ถูกต้อง (รูปแบบ HH:MM)'
  },
//   max_time(max) {
//     return value => {
//       const [max_hour, max_minute] = max.split(':')
//       const [value_hour, value_minute] = value.split(':')
//       const max_dt = moment().set({ hour: max_hour, minute: max_minute })
//       const value_dt = moment().set({ hour: value_hour, minute: value_minute })
//       return (
//         value_dt.isSameOrBefore(max_dt) ||
//         `กรุณากรอกเวลาไม่เกิน ${max}`
//       )
//     }
//   },
//   is_datetime(value) {
//     if (!value) return true
//     return (
//       moment(value, 'YYYY-MM-DD - HH:mm').isValid() ||
//       'กรุณากรอกวันที่และเวลาให้ถูกต้อง (รูปแบบ YYYY-MM-DD - HH:mm)'
//     )
//   },
  email: value => !value || /.+@.+\..+/.test(value) || 'กรุณากรอกอีเมลให้ถูกต้อง',
  validateUrlRule(value) {
    const pattern = new RegExp(
      '^(https?:\\/\\/)' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ) // fragment locator
    if (pattern.test(value)) {
      return true
    }
    return 'กรุณากรอก URL ให้ถูกต้อง'
  },
  numberic_or_operator: value =>
    !value || /^[0-9.()%+*/-]+$/.test(value) || 'รูปแบบไม่สามารถคำนวณได้',
  valid_mobile: value =>
    !value ||
    /^0(6|8|9|2|3|4|5|7)\d{7,8}$/.test(value) ||
    'กรุณากรอกเบอร์โทรศัพท์มือถือให้ถูกต้อง',

  is_array_limit(max, limit) {
    return value => {
      if (!value || value.length === max || value.length <= limit) return true
      return `กรุณาเลือกข้อมูลไม่เกิน ${limit} รายการ`
    }
  },
}